<script lang="ts">
    import {Component} from 'vue-facing-decorator';
    import {PersonBoxUser} from './PersonBoxUser.vue';

    @Component({
        name: 'PersonBoxRole',
    })
    export default class PersonBoxRole extends PersonBoxUser
    {
        type: PersonBoxTypes = 'role';

        hasTooltip: boolean = false;
    }
</script>